import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'wilson-score-bar',
  templateUrl: './score-bar.component.html',
  styleUrls: ['./score-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class ScoreBarComponent {
  @Input()
  widthPercentage!: number;

  @Input()
  backgroundColor!: string;

  @Input()
  size: 'small' | 'large' = 'small';
}
